/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVOpenIcon16Solid = forwardRef('ArrowCollapseCVOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.591 2.073a2.25 2.25 0 0 0-3.182 0L3.616 4.866a1.25 1.25 0 0 0 1.768 1.768L8 4.018l2.616 2.616a1.25 1.25 0 1 0 1.768-1.768L9.591 2.073Z" }),
        React.createElement("path", { d: "M9.591 13.927a2.25 2.25 0 0 1-3.182 0l-2.793-2.793a1.25 1.25 0 0 1 1.768-1.768L8 11.982l2.616-2.616a1.25 1.25 0 1 1 1.768 1.768l-2.793 2.793Z" })));
});
